<script setup lang="ts">
// Step 2: "projects = agents" — three stylised agent avatars on a row,
// each a phone-receiver-as-head pictogram. The middle one is featured.
</script>

<template>
  <div class="relative h-full w-full flex items-center justify-center">
    <svg
      viewBox="0 0 320 220"
      class="h-full w-auto"
      role="img"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="wg-proj-card" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="rgb(var(--surface))" stop-opacity="0.95" />
          <stop offset="100%" stop-color="rgb(var(--surface))" stop-opacity="0.6" />
        </linearGradient>
        <linearGradient id="wg-proj-accent" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="rgb(var(--accent))" />
          <stop offset="100%" stop-color="#f59e0b" />
        </linearGradient>
      </defs>

      <!-- side card (left) -->
      <g transform="translate(28 64) rotate(-6 64 56)">
        <rect width="128" height="112" rx="14" fill="url(#wg-proj-card)" stroke="rgb(var(--border))" />
        <circle cx="36" cy="44" r="18" fill="rgb(var(--accent))" opacity="0.18" />
        <path
          d="M30 38 q0 -10 6 -10 q6 0 6 10 v6 a6 6 0 0 1 -6 6 a6 6 0 0 1 -6 -6 z"
          fill="rgb(var(--accent))"
        />
        <rect x="64" y="38" width="50" height="6" rx="3" fill="rgb(var(--text-muted))" opacity="0.6" />
        <rect x="64" y="50" width="38" height="5" rx="2.5" fill="rgb(var(--text-muted))" opacity="0.35" />
        <rect x="16" y="80" width="96" height="6" rx="3" fill="rgb(var(--text-muted))" opacity="0.25" />
        <rect x="16" y="92" width="64" height="6" rx="3" fill="rgb(var(--text-muted))" opacity="0.25" />
      </g>

      <!-- side card (right) -->
      <g transform="translate(164 64) rotate(6 64 56)">
        <rect width="128" height="112" rx="14" fill="url(#wg-proj-card)" stroke="rgb(var(--border))" />
        <circle cx="36" cy="44" r="18" fill="#d946ef" opacity="0.18" />
        <path
          d="M30 38 q0 -10 6 -10 q6 0 6 10 v6 a6 6 0 0 1 -6 6 a6 6 0 0 1 -6 -6 z"
          fill="#d946ef"
        />
        <rect x="64" y="38" width="50" height="6" rx="3" fill="rgb(var(--text-muted))" opacity="0.6" />
        <rect x="64" y="50" width="38" height="5" rx="2.5" fill="rgb(var(--text-muted))" opacity="0.35" />
        <rect x="16" y="80" width="96" height="6" rx="3" fill="rgb(var(--text-muted))" opacity="0.25" />
        <rect x="16" y="92" width="64" height="6" rx="3" fill="rgb(var(--text-muted))" opacity="0.25" />
      </g>

      <!-- featured center card -->
      <g transform="translate(96 44)">
        <rect width="128" height="132" rx="16" fill="rgb(var(--surface-elevated))" stroke="url(#wg-proj-accent)" stroke-width="2" />
        <circle cx="64" cy="48" r="26" fill="url(#wg-proj-accent)" opacity="0.18" />
        <!-- headset/receiver glyph -->
        <g transform="translate(64 48)" fill="url(#wg-proj-accent)">
          <path d="M-10 -10 q0 -14 10 -14 q10 0 10 14 v10 a10 10 0 0 1 -10 10 a10 10 0 0 1 -10 -10 z" />
          <circle cx="0" cy="-16" r="3" fill="white" opacity="0.85" />
        </g>
        <rect x="22" y="88" width="84" height="7" rx="3.5" fill="rgb(var(--text))" opacity="0.85" />
        <rect x="32" y="102" width="64" height="6" rx="3" fill="rgb(var(--text-muted))" opacity="0.6" />
        <!-- status pill -->
        <g transform="translate(40 116)">
          <rect width="48" height="14" rx="7" fill="rgb(var(--accent))" opacity="0.15" />
          <circle cx="9" cy="7" r="3" fill="rgb(var(--accent))" />
          <rect x="16" y="3.5" width="24" height="6" rx="3" fill="rgb(var(--accent))" />
        </g>
      </g>
    </svg>
  </div>
</template>
